export const VIEW_RESET_STYLES = {
  boxSizing: 'border-box',
  border: 'unset',
  margin: 0,
  padding: 0,
} as const;
